export enum TransactionStatus {
  CREATED = 'created',
  PROCESSING = 'processing',
  FAILED = 'failed',
  SUCCEED = 'succeed',
}
